// extracted by mini-css-extract-plugin
export default {"root":"R8FSL"};